/* eslint-disable no-console */
import { useIntl } from "react-intl"
import styled from "styled-components/macro"
import * as Ct from "ldlj"
import {
  InteractionRequiredAuthError,
  PublicClientApplication,
} from "@azure/msal-browser"

import { Background } from "../../components/Background"
import { ReactComponent as LoginSVG } from "../../assets/illustration_connexion.svg"
import { sizes } from "../../styles/design.config"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { Text } from "../../components/Commons/Text"
import { jwtDecode } from "jwt-decode"
import { useEffect } from "react"
import { useRNBSelector } from "../../store/rootReducer"
import { getUserFromSSOThunk } from "../../store/ducks/user.ducks"

const UserSSO = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { loginStatus } = useRNBSelector((state) => ({
    loginStatus: state.login.status,
  }))

  useEffect(() => {
    if (loginStatus === "LOGGED") {
      navigate("/office")
    }
  }, [loginStatus])

  return (
    <Background centeredTop={false}>
      <Content>
        <Ct.Title text={intl.formatMessage({ id: "login.title" })} />
        <Ct.Subtitle
          text={intl.formatMessage({
            id: "login.subtitle",
          })}
        />
        <Ct.Spacer height={9} />
        <RowStyle>
          <StyledLoginSVG height={300} />
          <Ct.Card>
            <Text text={intl.formatMessage({ id: "login.sso.description" })} />
            <Ct.Spacer />
            <Ct.Button
              width={sizes.button.standard}
              label={intl.formatMessage({ id: "login.sso.cta" })}
              onClick={() => {
                // const JWTtest =
                //   "eyJ0eXAiOiJKV1QiLCJub25jZSI6InJkYWpReXhtc3hOd3Bia1VUNzdmRmRJLTh0dndVV2NyTDhOMGNIZFcwcEUiLCJhbGciOiJSUzI1NiIsIng1dCI6IlhSdmtvOFA3QTNVYVdTblU3Yk05blQwTWpoQSIsImtpZCI6IlhSdmtvOFA3QTNVYVdTblU3Yk05blQwTWpoQSJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC80MWQ5YTM4OC03YWVmLTQyMGQtOTc2Yy1kMDQ2YmVhYjY0MWYvIiwiaWF0IjoxNzExNTMwOTQ3LCJuYmYiOjE3MTE1MzA5NDcsImV4cCI6MTcxMTUzNTk4NiwiYWNjdCI6MCwiYWNyIjoiMSIsImFpbyI6IkFUUUF5LzhXQUFBQVQreTAxWmJ6QVRVeXFjMERzaFY5WFBLNmhLbk9UMEhtNmQrdEJNa3IzWkZ1aU1WUlo5SmRodGUwWmk3bEhwYmMiLCJhbXIiOlsicHdkIiwicnNhIl0sImFwcF9kaXNwbGF5bmFtZSI6Ik1hemFycyBDaGFpbnRydXN0IiwiYXBwaWQiOiI4OWQ1Yjk3YS1iMTc4LTRlOGUtYjhjMy0zMzJlZDFkMmQxOTAiLCJhcHBpZGFjciI6IjAiLCJkZXZpY2VpZCI6IjMyNWQzZTc3LWY2ZGUtNDUzNi1hMTk1LWYyNDJhMzk4YWE0YSIsImZhbWlseV9uYW1lIjoiQ1VSS0dJQU4iLCJnaXZlbl9uYW1lIjoiQ8OpZHJpYyIsImlkdHlwIjoidXNlciIsImlwYWRkciI6IjE0Ny4xNjEuMjMzLjk0IiwibmFtZSI6IkNVUktHSUFOIEPDqWRyaWMiLCJvaWQiOiIxNzVmMTZkMC05NzJjLTQ2MWYtYjM2MC04ZWQ4YWZmMmFlMDEiLCJvbnByZW1fc2lkIjoiUy0xLTUtMjEtNDE0NzM0NjkxMC05Njk1Nzc0MjEtNzA4ODUyNjE0LTE3NzA1MCIsInBsYXRmIjoiMyIsInB1aWQiOiIxMDAzMjAwMUNGRjhGRDM2IiwicmgiOiIwLkFRVUFpS1BaUWU5NkRVS1hiTkJHdnF0a0h3TUFBQUFBQUFBQXdBQUFBQUFBQUFBYkFYOC4iLCJzY3AiOiJvcGVuaWQgcHJvZmlsZSBVc2VyLlJlYWQgZW1haWwiLCJzaWduaW5fc3RhdGUiOlsiZHZjX21uZ2QiLCJkdmNfZG1qZCIsImttc2kiXSwic3ViIjoiUFFCTlgwcjM3TS1Yczd2SGVEcm1OWWhySUVsLV9JbElKMWJ5MHBvMUZwWSIsInRlbmFudF9yZWdpb25fc2NvcGUiOiJFVSIsInRpZCI6IjQxZDlhMzg4LTdhZWYtNDIwZC05NzZjLWQwNDZiZWFiNjQxZiIsInVuaXF1ZV9uYW1lIjoiY2VkcmljLmN1cmtnaWFuQG1hemFycy5mciIsInVwbiI6ImNlZHJpYy5jdXJrZ2lhbkBtYXphcnMuZnIiLCJ1dGkiOiJLNjRFMWZKTW1VaV9JM25tOE9uREFBIiwidmVyIjoiMS4wIiwid2lkcyI6WyJiNzlmYmY0ZC0zZWY5LTQ2ODktODE0My03NmIxOTRlODU1MDkiXSwieG1zX3N0Ijp7InN1YiI6IlRtTGxxT2pYeEdrSjBKSFVmTVBKYkl4a2hhdGtIcDdFNHNWWGVicUtPTVUifSwieG1zX3RjZHQiOjEzNTY1OTgwNDksInhtc190ZGJyIjoiRVUifQ.Cjs5bCrCtNaIZ2LFb_WAsSteqckyauU6fVyjtQlTwPUD_ZrlwJbqy-DoX_jXgwGYSetAor2sCqFfaris6pxYabeYklYofaT0j_IbWBVY5c7dbSLyXtk1gwQTlvHLoYEqgpErESvE52RLRGItAERepSVkBMwLX4rCynDZa9UulksT9Qxw0wz_jWepEjRB2z_J2Zz3eNgLnpsjxkywc38EeU0xUk_-MMPNzfjbyb9NY4pAgHKkRxhLOrqvLRr5G_VAB77k00fNCN7u9hqARaPMFC8ip1a98XxIZHw7zqJoPtFexyM7YFE-A0BFv5A4_xoi7-nNGFgyAyNJWn9qpaq74A"
                // const { upn, tid } = jwtDecode<{ upn: string; tid: string }>(
                //   JWTtest
                // )
                // dispatch(getUserFromSSOThunk(upn, tid))

                const msalConfig = {
                  auth: {
                    clientId: "89d5b97a-b178-4e8e-b8c3-332ed1d2d190",
                    authority:
                      "https://login.microsoftonline.com/41d9a388-7aef-420d-976c-d046beab641f",
                  },
                }
                const msalInstance = new PublicClientApplication(msalConfig)
                msalInstance.initialize().then(() => {
                  var request = {
                    scopes: ["User.Read"],
                  }
                  msalInstance
                    .acquireTokenSilent(request)
                    .then((tokenResponse) => {
                      const { upn, tid } = jwtDecode<{
                        upn: string
                        tid: string
                      }>(tokenResponse.accessToken)
                      dispatch(getUserFromSSOThunk(upn, tid))
                    })
                    .catch(async (error) => {
                      if (error instanceof InteractionRequiredAuthError) {
                        // console.log("error InteractionRequiredAuthError")
                        // fallback to interaction when silent call fails
                        console.log(`error if ${error}`)
                      }
                      console.log(`error ${error}`)
                      return msalInstance
                        .acquireTokenPopup(request)
                        .then((tokenResponse) => {
                          const { upn, tid } = jwtDecode<{
                            upn: string
                            tid: string
                          }>(tokenResponse.accessToken)
                          dispatch(getUserFromSSOThunk(upn, tid))
                        })
                        .catch((error) => {
                          console.log(`error ${error}`)
                        })
                    })
                })
              }}
            />
          </Ct.Card>
        </RowStyle>
      </Content>
    </Background>
  )
}
export default UserSSO

const RowStyle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 5rem;
`

const StyledLoginSVG = styled(LoginSVG)`
  height: 300px;
  padding-right: 30rem;
`
